module.exports = __webpack_public_path__ + "static/media/5-custom-cut-passepartout-online-delivery-service-canada-and-usa.6c319108.jpg";